import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { SliderWithInput } from '@/components/slider/slider_with_input';
import { useOrderFormCoordinator } from '../hooks/useOrderFormCoordinator';
import type { OrderFormData } from '../order_schema';

export function OrderSliderField() {
  const formContext = useFormContext<OrderFormData>();
  const sideWatch = useWatch({ control: formContext.control, name: 'side' });
  const { handleSliderChange } = useOrderFormCoordinator();

  return (
    <Controller
      name="orderSlider"
      control={formContext.control}
      render={({ field }) => (
        <SliderWithInput
          value={field.value}
          color={sideWatch === 'long' ? 'success' : 'error'}
          onChange={(value) => {
            field.onChange(value);
            handleSliderChange(value);
          }}
        />
      )}
    />
  );
}
